// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__XBsso","headerContainer":"header_headerContainer__VyWqw","logoIcon":"header_logoIcon__BL8TM"};